<template>
  <div
      class="remote_text"
      :class="meetingStatusProps !== 'on'? '' : 'hidden'"
  >
    <img
        src="https://bucket.rebless.pro/clinic/logo/rebless-clinic-logo.svg"
        style="width:300px;"
        alt=""
    >
    <LoaderView
        :class="meetingStatusProps === 'connecting' ||
        meetingStatusProps === 'stopping' ||
        meetingStatusProps === 'reconnecting' ? '' : 'hidden'"
    />
    <span :class="meetingStatusProps === 'waiting' && progressTimeProps === 0 ? 'remote_status_ment' : 'hidden'">{{ $t('RMC.click_rmc_button') }}</span>
    <span :class="meetingStatusProps === 'waiting' && progressTimeProps !== 0 ? 'remote_status_ment' : 'hidden'">{{ $t('RMC.done_call') }}</span>
    <span :class="meetingStatusProps === 'off' ? 'remote_status_ment' : 'hidden'">{{ $t('RMC.did_not_turn_camera') }}</span>
    <span :class="meetingStatusProps === 'left'? 'remote_status_ment' : 'hidden'">{{ $t('RMC.patient_left') }}</span>
    <span :class="meetingStatusProps === 'connecting'?  'remote_status_ment' : 'hidden'">{{ $t('RMC.waiting_for_patient') }}</span>
    <span :class="meetingStatusProps === 'stopping'?  'remote_status_ment' : 'hidden'">{{ $t('RMC.ending_meeting') }}</span>
    <span :class="meetingStatusProps === 'reconnecting'?  'remote_status_ment' : 'hidden'">{{ $t('RMC.try_reconnecting') }}</span>
  </div>
</template>
<script>
import LoaderView from '@/views/LoaderView';
export default {
  name : 'meetingStatus',
  props: ['meetingStatusProps', 'progressTimeProps'],
  components :{LoaderView}
}
</script>